<div class="d-flex flex-column">
  <!-- Liste paginée -->
  <div class="d-flex flex-row flex-wrap">
    <div
      *ngFor="let object of objectsCurrentPage"
      class="d-flex flex-row itemLine bg-acwhite p-3 m-1"
      (click)="onClickObject(object)"
    >
      <app-list-item
        [text]="object[textProperty]"
        [text2]="object[textProperty2]"
        [iconRight]="false"
      >
      </app-list-item>
    </div>
  </div>

  <div
    class="d-flex flex-row justify-content-center align-items-center mb-2 gap-3"
    *ngIf="kioskMode && (previousVisible || nextVisible)"
  >
    <fa-icon
      class="buttonPaging"
      [icon]="'chevron-circle-left'"
      size="4x"
      (click)="previous()"
      [style.visibility]="previousVisible ? 'visible' : 'hidden'"
    >
    </fa-icon>
    <span *ngIf="nbPage > 1" style="min-width: 100px; text-align: center">
      {{ currentPage + 1 }} / {{ nbPage }}
    </span>
    <fa-icon
      class="buttonPaging"
      [icon]="'chevron-circle-right'"
      size="4x"
      (click)="next()"
      [style.visibility]="nextVisible ? 'visible' : 'hidden'"
    >
    </fa-icon>
  </div>
</div>
